<div class="login-container">
  <p-toast></p-toast>
  <div class="login-box">
    <div style="text-align: center">
      <img src="../../assets/images/Avalara.png" class="Header__Main__Logo__Primary" alt="Logo da sua aplicação">
    </div>
    <div style="text-align: center">
      <h2>ACELERADOR IMPLANTAÇÃO TCO</h2>
    </div>
    <div class="p-fluid">
      <h3>Utilizar a plataforma central para acesso aos aceleradores</h3>
    </div>
    <div style="align-items: center;">
      <a href="https://central-avalara.vetorit-solucoes.com.br" target="_blank" rel="noopener noreferrer">
        <p-button label="Acessar Produçao" class="custom-button"></p-button>
      </a>
      &nbsp;
      <a href="https://qa.central-avalara.vetorit-solucoes.com.br" target="_blank" rel="noopener noreferrer">
        <p-button label="Acessar Sandbox" class="custom-button"></p-button>
      </a>
    </div>
  </div>
</div>
<footer>
  <div style="text-align: left">F:1.0.1</div>
  <div style="text-align: left">B:{{ backendVersion }}</div>

</footer>